import React, { Fragment, useMemo } from "react";
import { Helmet } from "react-helmet-async";

import Header from "../../components/header/Header";
import Hero from "../../components/hero/hero";
import FeaturesSection from "../../components/FeaturesSection/FeaturesSection";
import About from "../../components/about/about";
import PolicySection from "../../components/PolicySection/PolicySection";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import Testimonial from "../../components/Testimonial/Testimonial";
// import TeamSection from "../../components/TeamSection/TeamSection";
import BlogSection from "../../components/BlogSection/BlogSection";
import CtaSection from "../../components/CtaSection/CtaSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import CaseStudySection from "../../components/ProjectSection/CaseStudy";

import logo from "../../images/flag/logo.png";

// Option A: Fetch all and map client-side
import { useSeo } from "../../hooks/useSeo";
import MarqueeTechnology from "../../components/Technology/MarqueeTechnology";
import Technology from "../../components/Technology/Technology";
// Option B: If backend supports per-path endpoint, use this instead
// import { useSeoByPath } from "../../hooks/useSeoByPath";

const staticMeta = {
  title: "IT Solutions & Digital Marketing in Alwar & India | RashTech Info",
  description:
    "RashTech Info offers web development, app development, SEO, SMO, and IT solutions in Alwar and across India. Scalable services to grow your business.",
  url: "https://rashtechinfo.com/",
  image: logo,
  siteName: "RashTech Info",
  keywords:
    "web development, app development, ecommerce solutions, ui ux design, seo services, graphic design, video editing, digital agency",
  themeColor: "#0A0D1C",
};

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: staticMeta.siteName,
  url: staticMeta.url,
  logo: "https://example.com/logo.png",
  sameAs: [
    "https://www.facebook.com/example",
    "https://www.linkedin.com/company/example",
    "https://twitter.com/example",
  ],
  contactPoint: [
    {
      "@type": "ContactPoint",
      contactType: "sales",
      email: "sales@example.com",
      telephone: "+1-555-000-0000",
      areaServed: "Worldwide",
      availableLanguage: ["en"],
    },
  ],
};

const HomePage = () => {
  const { seo, loading, error } = useSeo("/getSeo");
  const computed = useMemo(() => {
    const dynamic = {
      title: seo?.title,
      description: seo?.metaDescription,
      keywords: seo?.metaKeywords,
      canonicalUrl: seo?.canonicalUrl,
    };
    
    
    return {
      title: dynamic.title || staticMeta.title,
      description: dynamic.description || staticMeta.description,
      keywords: dynamic.keywords || staticMeta.keywords,
      url: dynamic.canonicalUrl || staticMeta.url,
      image: staticMeta.image,
      siteName: staticMeta.siteName,
      themeColor: staticMeta.themeColor,
    };
  }, [seo]);

  // console.log('asedf',computed);
  


  

  return (
    <Fragment>
      <Helmet>
        {/* Primary */}
        <title>{computed.title}</title>
        <meta name="description" content={computed.description} />
        {computed.keywords && <meta name="keywords" content={computed.keywords} />}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content={computed.themeColor} />
        {computed.url && <link rel="canonical" href={computed.url} />}

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={computed.siteName} />
        <meta property="og:title" content={computed.title} />
        <meta property="og:description" content={computed.description} />
        {computed.url && <meta property="og:url" content={computed.url} />}
        {computed.image && <meta property="og:image" content={computed.image} />}

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={computed.title} />
        <meta name="twitter:description" content={computed.description} />
        {computed.image && <meta name="twitter:image" content={computed.image} />}

        {/* Preconnect hints */}
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />

        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      </Helmet>

      <div>
        <Header />
        <main className="page_content">
          <Hero />
          <FeaturesSection />
          <About />
          <PolicySection />
          <ServiceSection />
          <ProjectSection />
          <Technology />
          <CaseStudySection />
          <BlogSection />
          <Testimonial />
          <CtaSection />
        </main>
        <Footer />
        <Scrollbar />
      </div>

      {/* Optional hidden diagnostics */}
      {error && <div style={{ display: "none" }}>SEO load error</div>}
      {loading && <div style={{ display: "none" }}>Loading SEO…</div>}
    </Fragment>
  );
};

export default HomePage;
